import createStorageSyncPlugin from "@/plugins/vuex-storage-sync";
import loadingStore from "@/store/modules/loading";
import studentStore from "@/store/modules/student";
import teacherStore from "@/store/modules/teacher";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Create the storage sync plugin
const storageSyncPlugin = createStorageSyncPlugin({
  states: [
    "student.currentScenario",
    "student.currentTopicId",
    "student.scenarioState",
    "teacher.classRollModalOpen",
    "teacher.currentClass",
    "teacher.classTournamentState",
  ],
});

export default new Vuex.Store({
  modules: {
    loading: loadingStore,
    student: studentStore,
    teacher: teacherStore,
  },
  plugins: [storageSyncPlugin],
});
